import React, { useEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import isEqual from "lodash-es/isEqual";

import {trapFocus, isfocusedInside , focusElement} from "../../Resources/globalFunctions"
import { GetState, GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { getDevice } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import DOMPurify from "dompurify";
import { functions } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import { useDispatch } from "react-redux";

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

function Alert(props) {
  return (
    <div id="customisedAlert_showconformationDialogBox" 
    style={
      props?.alertData?.placement?.vertical === "center" && props?.alertData?.placement?.horizontal === "center"
        ? { transform: "translate(0%, -100%)" }
        : {}
    }
    >
      <MuiAlert
        elevation={props.elevation ? props.elevation : 6}
        variant={props.variant ? props.variant : "filled"}
        icon={props?.showIcon}
        {...props}
      />
    </div>
  );
}
function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

function TransitionRight(props) {
  return <Slide {...props} direction="right" />;
}

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

function TransitionNormal(props) {
  return <Slide {...props} appear={false}/>;
}

const useStyles0 = makeStyles((theme) => ({
  root: {
    position: "absolute",
    zIndex: "9999999 !important",
    //bottom: "10px",
    left: "10px",
    width: "100%",
    "& #messageContainer" : {
      userSelect: "all",
      "-webkit-user-select": "all",
    },
   "& .MuiSnackbar-root": {
    top: (theme) => {
      if (theme?.alertData?.placement?.vertical === "center" && theme?.alertData?.placement?.horizontal === "center") {
        return "45%"; 
      }
      else if (theme?.alertData?.placement?.vertical === "bottom") {
        return "auto"; 
      } 
      else if(theme?.alertData?.placement?.horizontal === "left" || theme?.alertData?.placement?.horizontal === "right"  ) {
        return "12%";
      }
    },
  },
  "& .MuiSnackbar-anchorOriginTopCenter": {
    transition: "translate 0.3s ease-in-out",
    translate: (theme) => theme?.currentAlertIndex > 0 ? `0 calc(${theme?.currentAlertIndex} * (100% + 16px))` : "",
  },
    "& > * + *": {
      marginTop: theme.spacing(2)
    },
    "& .MuiAlert-message": {
      padding: "8px 20px",
      margin: theme=> theme.translationStyles1?"auto 10px auto 0px":"auto 0px auto 10px"
    },
    "& .MuiAlert-icon": {
      display: "inline",
      position: "absolute",
      padding: "9px 0",
      top: 8,
      left: theme=>theme.translationStyles1? null : 14,
      opacity: 0.9,
      margin: "auto"
    },
    "& .MuiAlert-action": {
      minHeight: "100%",
      right: 0,
      margin: "auto",
      padding: 0,
      marginRight: "8px",
      flexWrap: "wrap"
    }
  },
  addedTop: {
    "& .MuiSnackbar-anchorOriginTopCenter": {
      top: (theme) => (theme?.alertData?.placement?.keyAdded ? "unset" : "16px"),
    },
  },
}));

const useStyles = makeStyles({
  dialog: (props) => ({
    position: "absolute",
    left: "50%",
    bottom: "50%",
    maxWidth: 410,
    overflow: 'hidden',
    margin:"0px",
    transform: "translate(-50%,50%)",
    ...props,
  }),
  container: (style) => ({
    ...style.dialog,
    // height: "100%",
    marginLeft: "unset",
    left: "0px !important"
    // width: style => style.width,
  }),
  root: (style) => ({
...style.dialog,
marginRight: '0px !important',
left: "0px !important",
"& .MuiBackdrop-root": {
  ...style.dialog,
  left: "0px !important"
}
}),
  root1: (style) => ({ marginRight: '0px !important'}),
});

function CustomizedAlert(props) {

  const deviceType = getDevice();

  const contexts = GetStateFromData();
  const {tempCanHeight, tempCanWidth, alertStack } = GetState("tempCanHeight","tempCanWidth", "alertStack");
  const { deleteControl, containerId, canvasTop, showPagesSubForms } = contexts.contexts;

  const [currentAlertId, setCurrentAlertId] = useState(props?.uniqueID || new Date().getTime());
  const dispatch = useDispatch()

  const currentAlertIndex = alertStack?.findIndex(alert => alert === currentAlertId);

  const [dialogStyle, setDialogStyle] = useState({});

   useEffect(() => setDialogDimension(), [tempCanHeight, tempCanWidth]);

   useEffect(() => {
    if(props.alertData && props?.alertData?.showConfirm !== "showconformationDialogBox") {
      dispatch({ type: "ADD_NEW_ALERT", payload: currentAlertId })
    }

    return () => {
      if(props.alertData && props?.alertData?.showConfirm !== "showconformationDialogBox") {
        dispatch({ type: "REMOVE_ALERT", payload: currentAlertId })
      } 
    }
   }, [currentAlertId, dispatch])

    const setDialogDimension = () => {
        // if (formMataData) {
          const canvasElement = document.getElementById("canvasId");
    
          if (canvasElement) {
            const newStyles = {
              top: window.leftNavigationPanelOpen || showPagesSubForms ? '' : `calc(${canvasTop}px - 12px) !important`,
              left: window.leftNavigationPanelOpen || showPagesSubForms ? '' : `${document.getElementById("canvasId").getBoundingClientRect().left}px !important`,
              width: window.leftNavigationPanelOpen || showPagesSubForms ? '' : `${tempCanWidth}px`,
              height: window.leftNavigationPanelOpen || showPagesSubForms ? '' : `calc(${tempCanHeight}px + 12px)`
            };
    
            setDialogStyle(newStyles);
          }
        // }
      };

  const alertBodyStyleReceived =
    props.alertData && props.alertData.alertBodyStyle ? props.alertData.alertBodyStyle : {};
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";     
  const styleObj = props?.alertData?.styleObj 

  const classes = useStyles({ ...alertBodyStyleReceived });
  const classes0 = useStyles0({...props,translationStyles1, currentAlertIndex});

  const { t } = useTranslation();

  const T = (str) => {
    return t(str, {
      nsSeparator: false,
      keySeparator: false,
    })
  }

  const isClose =
    props?.alertData && props?.alertData?.isClose !== undefined && props?.alertData?.isClose + ""
      ? props?.alertData?.isClose
      : true;
  
  const showIcon =
    props?.alertData && props?.alertData?.showIcon !== undefined && props?.alertData?.showIcon + ""
      ? props?.alertData?.showIcon
      : true;

  // these alert types are supported: [error, warning, info, success]

  const reduxContexts = contexts;

  // Notification message transiting direction
  var Transition =
    props && props.alertData && props.alertData.slideDirection === "up"
      ? TransitionUp
      : props.alertData && props.alertData.slideDirection === "down"
      ? TransitionDown
      : props.alertData && props.alertData.slideDirection === "right"
      ? TransitionRight
      : props.alertData && props.alertData.slideDirection === "left" ?
      TransitionLeft : TransitionNormal;

  // Notification message appearing position
  var sliderDirection = {
    vertical: "top",
    horizontal: "center"
  };

  sliderDirection = {
    vertical: props?.alertData?.placement?.vertical || sliderDirection.vertical,
    horizontal: props?.alertData?.placement?.horizontal || sliderDirection.horizontal
  };

  var { vertical, horizontal } = sliderDirection;

  const [open, setOpen1] = useState(false);
  const open2 = useRef();
  const setOpen = (val) => {
    open2.current = props.alertData.open;
    setOpen1(val);
  }

  // const trapRef = useFocusTrap();

  useEffect(() => {
    if(props?.alertData && props?.alertData?.open) {
      setOpen(props.alertData && props.alertData.open);
    }
  }, [props.alertData]);

  // Type of notification message
  var alertType = props.alertData && props.alertData.alertType ? props.alertData.alertType : "info";

  //autoHideDuration in milli-seconds
  var autoHideDuration = props.alertData && (props.alertData.autoHideDuration || props.alertData.autoHideDuration === null) ? props.alertData.autoHideDuration : 5000;
  //Default elevation will be 6, it should be a number rather than a string or char
  var elevation = props.alertData && props.alertData.elevation ? props.alertData.elevation : 6;

  //Default alert will be filled
  var variant = props.alertData && props.alertData.variant ? props.alertData.variant : "filled";
  var alertTitle =
    props.alertData && props.alertData.alertTitleKey && props.alertData.dynamicTitle
      ? props.alertData.alertTitleKey
      : props.alertData && props.alertData.alertTitleKey
      ? T(props.alertData.alertTitleKey)
      : props.alertData && props.alertData.alertTitleMsg
      ? props.alertData.alertTitleMsg
      : "Are you sure you want to perform this operation ?";

  //a customized alert message
  var alertMsg =
      props?.alertData?.alertContentKey
      ? T(props.alertData.alertContentKey)
      : props?.alertData?.alertContentMsg
      ? T(props.alertData.alertContentMsg)
      : T("Once you perform you will make changes are you sure you want to perform this operation.");

      function containsHTML(str) {         
        const doc = new DOMParser().parseFromString(str, "text/html");
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); 
      }

      const messageContainerEl = useRef(null);
      const alertDia = useRef(null);
            
      useEffect(() => {
        const messageContainer = messageContainerEl.current;      
        const alertDialog = alertDia.current;
        const htmlContent = alertMsg;
        const hasHtmlTags = containsHTML(htmlContent);

        if(messageContainer){
          if (hasHtmlTags) {
            const __sanitized1 = DOMPurify.sanitize(htmlContent);
            const __doc1 = new DOMParser().parseFromString(__sanitized1, 'text/html');
            messageContainer.replaceChildren(...Array.from(__doc1.body.childNodes));
          } else {
            messageContainer.innerText = htmlContent;
          }
        }
        if(alertDialog){

          if (hasHtmlTags) {
            const __sanitized2 = DOMPurify.sanitize(htmlContent);
            const __doc2 = new DOMParser().parseFromString(__sanitized2, 'text/html');
            alertDialog.replaceChildren(...Array.from(__doc2.body.childNodes));
          } else {
            alertDialog.innerText = htmlContent;
          }
        }

        }, [alertMsg, open, messageContainerEl.current, alertDia.current]);

        useEffect(() => {

            if(props.alertData && props.alertData.showConfirm === "showconformationDialogBox" && open2.current === false) {
              const alertNode = document.getElementById(`custom-alert-${currentAlertId}`);
              if (alertNode) {
                console.log("Removing alert...");
                if (alertNode._reactRoot) {
                  alertNode._reactRoot.unmount();
                }
                // ReactDOM.unmountComponentAtNode(alertNode); 
                alertNode.remove(); 
              } else {
                console.error("Alert container not found");
              }
            }
        },[open])

      // useEffect(() => {
      // const messageContainer = document.getElementById("messageContainer");      
      // const alertDialog = document.getElementById("alert-dialog-slide-description");
      // const htmlContent = T(props.alertData?.alertContentMsg);
      // const sanitizedHtml = DOMPurify.sanitize(htmlContent);
      
      //       if(messageContainer){
      //         messageContainer.innerHTML = sanitizedHtml;
      //       }
      //       if(alertDialog){
      //         alertDialog.innerHTML = sanitizedHtml;
      //       }
          
      // }, [props.alertData?.alertContentMsg, open]);
  
  async function handleClose(strMsg, event, labelName,callback) 
  {if(props?.alertData?.onClose) {
    props.alertData.onClose();
  }

      if(props.alertData && props?.alertData?.showConfirm !== "showconformationDialogBox") {
        dispatch({ type: "REMOVE_ALERT", payload: currentAlertId })
      } 
        if (labelName && callback) {
      callback(labelName);
      functions.updateJSON()
      if(props?.alertData?.open)
        props.alertData.open = false;
      setOpen(false);
      return;
    }
    if(props.fromWizard && labelName === "Yes" && window.wizardSubmitPortalHook_yes){
      window.wizardSubmitPortalHook_yes();
    }
    if(props.fromWizard && labelName === "No" && window.wizardSubmitPortalHook_no){
      window.wizardSubmitPortalHook_no();
    }

    if (strMsg === false) {
      if (props.alertData.action === "submitApplication") {
        props.handleFunction("N");
        // if(props.fromWizard && window.wizardSubmitPortalHook_yes){
        //   window.wizardSubmitPortalHook_yes();
        // }
        if(window.workItemSubmissionConfirmationHook)
          window.workItemSubmissionConfirmationHook(strMsg)
          functions.updateJSON();
      }
      if (props.alertData?.Button1Key ==="Ok"){
        props?.callOnClose();
        if(props?.alertData?.open)
          props.alertData.open = false;
        setOpen(false);
      }
      if (props.alertData?.Button1Key ==="Cancel" && props.alertData?.leftRightAlignmentNotApply){
        props.alertData?.leftRightAlignmentNotApply();
        // if(props.fromWizard && window.wizardSubmitPortalHook_no){
        //   window.wizardSubmitPortalHook_no();
        // }
        if(props?.alertData?.open)
          props.alertData.open = false;
        setOpen(false);
      }
      if (props.alertData?.Button1Key ==="Cancel" && props.alertData?.cancelFunction){
        props.alertData.cancelFunction();
        if(props?.alertData?.open)
          props.alertData.open = false;
        setOpen(false);
      }      
      if(props.alertData?.Button1Key === "CancelButton"){
          if(props?.alertData?.open)
           props.alertData.open = false;
          setOpen(false);
          
        }
      if (props.alertData?.routeByPageName){
        if(props?.alertData?.open)
          props.alertData.open = false;
        setOpen(false);
        props.alertData.setIsLoading(false);
      }
    }
    if (strMsg === true) {
      if (props.alertData?.Button2Key === "Confirm") {
        // if(props.fromWizard && window.wizardSubmitPortalHook_yes){
        //   window.wizardSubmitPortalHook_yes();
        // }
        if (props.alertData?.pageType === "page") {
          props.alertData?.setCurrentPage(props.alertData?.pageProps);
          if(props?.alertData?.open)
            props.alertData.open = false;
          setOpen(false);
        }
        else if (props.alertData?.Button2Key === "Confirm" && props.alertData.deleteRecord) {
          props.alertData.deleteRecord("Enter");
          if(props?.alertData?.open)
           props.alertData.open = false;
          setOpen(false);
        } 
        else if(props.alertData.routeByPageName){
       if(props.alertData.hookName !== "goToHomeOnWizSubmitHook"){
       if (typeof props.alertData.formName === "string") {
           const isEmpty = props.alertData.formName.length === 0;
           const isWhitespaceOrEmpty = props.alertData.formName.trim() === "";

        if (isEmpty || isWhitespaceOrEmpty) {
        if (props.alertData.hookName === "routeOnwiz_saveNexit_Hook") {
        if (props.alertData.routeOnSE) 
           props.alertData.logoutFunc();                    
           props.alertData.setIsLoading(false);
           setOpen(false);
       } else if (props.alertData.hookName === "routeOnwiz_Cancel_Hook") {
            window.location.reload(false); 
            setOpen(false);
       }
      } else {
        props.alertData.routeByPageName(props.alertData.hookName);
        setOpen(false);
      }
        }
      }else{
        props.alertData.routeByPageName();
      }
        }
        else if (props.alertData?.pageType === "subform") {
          props.alertData?.setCurrentSubform(props.alertData?.pageProps);
          if(props?.alertData?.open)
           props.alertData.open = false;
          setOpen(false);
        } else if (props.alertData?.saveTable === true) {
          props.alertData.saveTableData(props.alertData?.saveTableJSON).then(() => {
            props.alertData.searchTableFunc(props.alertData.searchEvent, props.alertData.searchValue, props?.alertData?.columnStyle);
          });
        }
         else if (props?.alertData?.clearFunction) {
          props.alertData.clearFunction();
          if(props?.alertData?.open)
           props.alertData.open = false;
          setOpen(false);
        }
      } else if (props.alertData?.Button2Key === "Yes" && props.alertData.manualordatabase) {
        
        props.alertData.handleDataClearFromOptions(props.alertData.btnDetails);
        if(props?.alertData?.open)
          props.alertData.open = false;
        setOpen(false);
      } else if (props.alertData?.Button2Key === "Yes" && props.alertData.deleteSubmenus) {
        await props.alertData.deleteSubmenus();
        if(props?.alertData?.open)
         props.alertData.open = false;
        setOpen(false);
      }
      else if (props.alertData?.Button2Key === "Change to style 1" && props?.alertData?.leftRightAlignmentApply) {
        props?.alertData?.leftRightAlignmentApply();
        if(props?.alertData?.open)
         props.alertData.open = false;
        setOpen(false);
      }
      else if (props.alertData?.Button2Key === "Clear" && props?.alertData?.clearFunction) {
        props?.alertData?.clearFunction();
        if(props?.alertData?.open)
         props.alertData.open = false;
        setOpen(false);
      }
      else if (props.alertData?.Button2Key === "ConfirmUpload") {
          props.alertData?.ReplaceSubForm()
          if(props?.alertData?.open)
           props.alertData.open = false;
          setOpen(false);
        }  
      else if (props.alertData?.Button2Key === "Yes"){
        // if(props.fromWizard && window.wizardSubmitPortalHook_yes){
        //   window.wizardSubmitPortalHook_yes();
        // }
      }
      else if (props.alertData?.Button2Key === "No"){
        // if(props.fromWizard && window.wizardSubmitPortalHook_no){
        //   window.wizardSubmitPortalHook_no();
        // }
      }
      
     
    }
    if(props?.alertData?.open)
      props.alertData.open = false;
    setOpen(false);
    try {
      if (props.setOpenLoader !== undefined) {
        props?.setOpenLoader((prev) => !prev);
      }
    } catch (error) {}

    if (strMsg === true) {
      if (props.alertData.controlId) {
        deleteControl(event, props.alertData.controlId, props.alertData.data);
      } else if(props.alertData.conditionalVisibility) {
        props.handleFunction(props.alertData.arg);
      } else if (props.alertData.Button2Key === "LoginButton") {
        props.alertData.forceLogin();
      } else if (props.alertData.deleteCB && props.alertData.pageToDelete) {
        props.alertData.deleteCB(props.alertData.pageToDelete);
      } else if (props.handleFunction) {
        if (props.alertData.sheetIndex || props.alertData.sheetIndex === 0)
          props.handleFunction(props.alertData.Id, props.alertData.sheetIndex);
        else {
          props.handleFunction(props.alertData.Id);
           if (props.alertData.action === "submitApplication") {
                if(window.workItemSubmissionConfirmationHook)
                  window.workItemSubmissionConfirmationHook(strMsg)
                  functions.updateJSON();
            }
        }
      } else if (props.handleEventFunction) {
        props.handleEventFunction(props.evnt);
      } else if (props.alertData.deleteZone) {
        props.setDeleteCondition(true);
      } else if (props.alertData.addsubstep) {
        props.setToAddSubStep(true);
      } else if (props.alertData.confirmDeleteStep) {
        props.setConfirmDeleteStep(true);
      } else if(props.alertData.confirmDeleteSubStep) {
        props.setConfirmDeleteSubStep(true);
      }
       else if(props.alertData.attachSubForm) {
        props.setAttachSubForm(true);
      }
      else if (
        props.alertData.isAddMenu &&
        props.alertData?.addMenuObj &&
        typeof props.alertData?.addMenuObj?.cb === "function"
      ) {
        const { subKey, e, stepIndex, cb, subStepIndex } = props.alertData?.addMenuObj;

        if (subKey === "SubMenu") {
          cb(e, stepIndex, true);
        } else if (subKey === "SubChildMenu") {
          cb(e, stepIndex, subStepIndex, true);
        }
      } else if(props.alertData.isDeleteMenu && props.alertData?.deleteMenuObj && typeof props.alertData?.deleteMenuObj?.cb === "function") {
        const {subKey, e, stepIndex, cb, subStepIndex, subChildMenuIndex, stepDetails} = props.alertData?.deleteMenuObj;

        if (subKey === "Menu") {
          cb(stepIndex, stepDetails);
        } else if (subKey === "SubMenu") {
          cb(stepIndex, subStepIndex, e, stepDetails);
        } else if (subKey === "SubChildMenu") {
          cb(stepIndex, subStepIndex, subChildMenuIndex, e, stepDetails);
        }
      }
    }
  }

  function handleAdditionalFunction(buttonName, ev) {
    //here operations can be performed for additional buttons by passing correponding functions passed through props .
    buttonName();
    if(props?.alertData?.open)
      props.alertData.open = false;
    setOpen(false);
  }

  function agentHas(keyword) {
    return (
      window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) >
      -1
    );
  }

  let isSafariBrowser = function isSafari() {
    return (
      (!!window.ApplePaySetupFeature || !!window.safari) &&
      agentHas("Safari") &&
      !agentHas("Chrome") &&
      !agentHas("CriOS")
    );
  };

  const iconStylingData = {
    minWidth: "18px",
    minHeight: "18px",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    position: "relative"
  };
  const iconStylingData2 = {
    minWidth: "18px",
    minHeight: "18px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };
  const notificationBox = {
    maxWidth: "410px",
    minWidth: "360px",
    zIndex:"99999",
    minHeight: "41px",
    display: "flex",
    alignItems: "center",
    position: "relative",
    padding: "8px 16px",
    font: "normal normal 600 12px/17px Open Sans",
    boxShadow: "0px 3px 8px #000029",
    borderRadius: "2px",
    opacity: 1,
    boxSizing:props?.alertData?.boxStyle ? "border-box":null
  };
  const successNotificationBox = {
    color: "#000000",
    background: "#C9E29A 0% 0% no-repeat padding-box"
  };
  const infoNotificationBox = {
    background: "#005EA3 0% 0% no-repeat padding-box"
  };
  const warningNotificationBox = {
    background: "#AD6503 0% 0% no-repeat padding-box"
  };
  const errorNotificationBox = {
    color: "#FFFFFF",
    background: "#D53D3D 0% 0% no-repeat padding-box",
    top: isSafariBrowser() ? "45px": "0",
  };
  const whiteCrossIconButton = {
  };
  const whiteCrossIcon = {
    width: "10px",
    height: "10px",
    position: "absolute",
    right: translationStyles1 ? null : 10,
    left: translationStyles1 ? 10 : null,
    top: 10
  };

  const blackCrossIcon = {
    width: "10px",
    height: "10px",
    position: "absolute",
    color: "#FFFFFF",
    right: translationStyles1 ? null : 10,
    left: translationStyles1 ? 10 : null,
    top: alertType === "error"?20:10
  };

  const style1 = {};
  const dialogTitleBodyStyle = {
    padding: isClose ? "0px 0px 0px 0px" : window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "0px 0px 0px 15px" : "0px 15px 0px 0px",
    alignSelf: "center",
    width: 'calc(100% - 76px)'
  };

  const dialogBorderStyle = {
    borderWidth: "thin",
    borderStyle: "none none inset",
    borderColor: "silver",
    borderRadius: "2px",
  };

  const dialogTitleTextStyleProcessDesiger = {
    marginTop: "15px"
  };
  const dialogTitleTextStyle = {
    fontFamily: "Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    fontWeight: 600,
    lineHeight: "normal",
    font: "normal normal 600 14px/19px Open Sans",
    paddingLeft: (props.alertData && (props.alertData.icon1Src || props.alertData.icon1)) ? "8px" : "16px",
    // whiteSpace: "nowrap", // Commented for Bug 146067
    // textOverflow: "ellipsis", // Commented for Bug 146067
    overflow: "hidden"
    // paddingBottom: "3%",
    // marginLeft: "-11%"
  };

  const dialogContentBodyStyle = {
    padding: "0px 15px 0px 0px",
    marginBottom: "1rem",
    paddingRight: "0"
  };
  const dialogContentTextStyle = {
    fontSize: 12,
    fontFamily: "Open Sans",
    color: "#000000",
    letterSpacing: "0px",
    paddingLeft: "16px",
    paddingTop: "16px",
    paddingRight: "15px",
    font: "normal normal normal 12px/17px Open Sans"
  };
  const notificationIcon1ColStyle = {
    paddingLeft: "0px",
    paddingRight: translationStyles1? null :"15px",
    boxSizing:props?.alertData?.boxStyle ? "border-box":null
  };
  const notificationIcon2ColStyle = {
    paddingLeft: "0px",
    paddingRight: "0px",
    position: "absolute",
    width: "auto",
    right: 8,
    top: 8
  };
  const style2 = {};
  const buttonFooter = {
    background: " #F5F5F5 0% 0% no-repeat padding-box",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "0px",
    paddingBottom: "0px",
    flexWrap: "wrap",
    minHeight: "50px",
    backgroundColor: "#e7e7e7",
    gap: "12px",
  };
  const ButtonStyle1 = {
    height: "32px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    fontFamily: "Open Sans",
    fontSize: "12px",
    fontWeight: 600,
    color: "#606060",
    border: "1px solid #C4C4C4",
    textTransform: "none",
    borderRadius: "2px",
    opacity: 1
  };

  var backgroundc = "#0072C6";
  if (props?.alertData?.alertTitleKey && props.alertData.alertTitleKey === "Delete Confirmation") {
    backgroundc = "#D53D3D";
  }

  const ButtonStyle2 = {
    height: "32px",
    background: `${backgroundc} 0% 0% no-repeat padding-box`,
    fontFamily: "Open Sans",
    fontSize: "12px",
    fontWeight: 600,
    border: "1px solid #C4C4C4",
    color: "#FFFFFF",
    textTransform: "none",
    borderRadius: "2px",
    opacity: 1
  };
  const style6 = {
    width: "11px",
    height: "11px",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: "16px",
    paddingRight: "16px",
  };
  const style7 = {
    maxWidth: "16px",
    maxHeight: "16px",
    minWidth: "16px",
    minHeight: "16px",
    // display:'span',
    paddingRight: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "10px" : "0px",
    alignItems: "center",
    paddingLeft: "16px",
  };
  const ButtonStyle3 = {
    height: "32px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    fontFamily: "Open Sans",
    fontSize: "12px",
    fontWeight: 600,
    border: "1px solid #0072C6",
    color: "#0072C6",
    textTransform: "none",
    borderRadius: "2px",
    opacity: 1,
  };
  const extraButtonStyle = {
    padding: 0,
    textTransform: "none"
  };
  const additionalButtonStyle = {
    padding: 0,
    textTransform: "none",
    justifyContent: "flex-start"
  };
  const headerStyle = {
    display: "flex",
    alignItems: "center",
    flexDirection: "row"
  };
  const icon1ColStyle = {
    width: "33px",
    maxWidth: "33px",
    boxSizing: 'content-box',
    paddingTop: "15px",
    display: "flex",
    alignSelf: "flex-start"
  };
  const contentColStyle = {
    width: "100%",
    maxWidth: "100%",
  };
  const icon2ColStyle = {
    width: "43px",
    maxWidth: "43px",
    boxSizing: 'content-box',
    // paddingTop: "17px",
    // paddingLeft: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "15px" : "10px",
    // paddingRight: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "10px" : "15px",
    direction: "rtl",
    marginLeft: "auto",
    alignSelf: "center"
  };

  var customisedAlert_showconformationDialogBox = document.querySelector("#customisedAlert_showconformationDialogBox");

  function checkingTabbing(e){
      if(e.key==="Tab" ){
        const isInside= isfocusedInside(document.querySelector("#customisedAlert_showconformationDialogBox"));
        if(!isInside){
          focusElement( document.querySelector("#customisedAlert_showconformationDialogBox") );
        }
      }
  }

  useEffect(() => {
    window.addEventListener("keyup", checkingTabbing);

    return () => {
      window.removeEventListener('keyup', checkingTabbing);
    }
  }, [props.alertData])


  if (props.alertData && props.alertData.showConfirm === "showconformationDialogBox") {
    return (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          style={
            props.alertData && props.alertData.alertBodyBackgroundStyle ? translationStyles1? {direction:"rtl",...props.alertData.alertBodyBackgroundStyle} :props.alertData.alertBodyBackgroundStyle : translationStyles1?{direction:"rtl"}:null
          }
          classes={{paper:classes.dialog,root: classes.root, container: classes.container}}
          container={() => {document.getElementById("canvasId")}} 
        >
          <div style={{display:"block",minWidth:"270px"}} id="customisedAlert_showconformationDialogBox"  >
            <div
          style={
            props.alertData && props.alertData.bodyStyle
              ? { ...headerStyle, ...props.alertData.bodyStyle }
              : headerStyle
          }
        >
          <Col style={contentColStyle}>
            <div style={{display: 'flex',flexDirection: 'row',alignItems:'center',height: deviceType === "mobile" ? "auto" : '50px'}}>
            {
            showIcon && (props.alertData && (props.alertData.icon1Src || props.alertData.icon1)) &&
            <Col
              style={
                props.alertData && props.alertData.icon1Style
                  ? { ...icon1ColStyle, ...props.alertData.icon1Style,display: 'flex',alignItems: 'center',paddingTop: '0px', 'height': '50px'}
                  : {...icon1ColStyle, display: 'flex',alignItems: 'center',paddingTop: '0px', height: '50px'}
              }
            >
              {(props.alertData && (props.alertData.icon1Src || props.alertData.icon1)) && <img
                src={
                  props.alertData.icon1Src
                    ? props.alertData.icon1Src.src.default
                    : require("../../Icons/YellowTriangle.svg").default
                }
                alt="Img Icon"
                style={
                  props.alertData.icon1Src &&
                  props.alertData.icon1Src.styleData
                    ? { ...style7, ...props.alertData.icon1Src.styleData }
                    : style7
                }
              />}
            </Col>
            }
            <DialogTitle
              id="alert-dialog-slide-title"
              style={
                props.alertData && props.alertData.titleBodyStyle
                ? { ...dialogTitleBodyStyle, ...props.alertData.titleBodyStyle }
                : dialogTitleBodyStyle
              }
              >
              <p id="dialog-title"
                style={{
                  ...(props.alertData && props.alertData.titleTextStyle
                    ? { ...dialogTitleTextStyle, ...props.alertData.titleTextStyle }
                    : containerId === "mf_formBuilder"
                    ? dialogTitleTextStyle
                    : { ...dialogTitleTextStyle, ...dialogTitleTextStyleProcessDesiger }),
                    ...styleObj?.confirmTitle
                }}
              >
                {alertTitle}
              </p>
            </DialogTitle>
              {isClose && (
            <Col
              style={
                props.alertData && props.alertData.icon2Style
                  ? { ...icon2ColStyle, ...props.alertData.icon2Style }
                  : icon2ColStyle
              }
            >
              <img
                id={"alertcloseicon"}
                src={
                  props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                    ? props.alertData.icon2Src.src.default
                    : require("./Icons/GreyCross.svg").default
                }
                alt="Img Icon"
                style={
                  props.alertData &&
                  props.alertData.icon2Src &&
                  props.alertData.icon2Src &&
                  props.alertData.icon2Src.styleData
                    ? { ...style6, ...props.alertData.icon2Src.styleData }
                    : style6
                }
                tabIndex="0"
                onClick={(ev) => handleClose(false)}
              />
            </Col>
          )}
          </div>
              <div id="borderline" style={dialogBorderStyle}></div>
            <DialogContent id="alert-dialog-slide-description"
              style={
                props.alertData && props.alertData.contentBodyStyle
                  ? { ...dialogContentBodyStyle, ...props.alertData.contentBodyStyle }
                  : dialogContentBodyStyle
              }
            >
              <DialogContentText 
                style={{
                  ...(props.alertData && props.alertData.contentTextStyle
                    ? { ...dialogContentTextStyle, ...props.alertData.contentTextStyle }
                    : dialogContentTextStyle),
                    ...styleObj?.confirmBody
                }}
                id="alert-dialog-slide-description-text"
                ref={alertDia}
              >
                {alertMsg}
              </DialogContentText>
            </DialogContent>
          </Col>
            </div>

            <DialogActions id={"footer"}
          style={{
            ...(props.alertData && props.alertData.footerStyle
              ? { ...buttonFooter, ...props.alertData.footerStyle }
              : buttonFooter),
              ...styleObj?.confirmFooter
          }}
        >
          <Button
          className={`formBuilder-MuiButton-outlined ${classes.root}`}
          disableRipple
          disableTouchRipple
          tabIndex={0}
            style={{
              ...(props.alertData && props.alertData.Button1Style
                ? { ...ButtonStyle1, ...props.alertData.Button1Style }
                : ButtonStyle1),
                ...styleObj?.button1Style
            }}
            onClick={(ev) => handleClose(false, null, props.alertData?.Button1?.name ? props.alertData?.Button1?.name : props.alertData?.Button1Key, props.alertData?.Button1?.callback)}
            color="primary"
          >
            {props.alertData && props.alertData.Button1Key
              ? T(props.alertData.Button1Key)
              : props.alertData && props.alertData.Button1
              ? props.alertData.Button1.name
              : "Click"}
          </Button>

          {props.alertData && props.alertData.additionalButtons
            ? props.alertData.additionalButtons.map((buttonDetails, index) => {
                if (buttonDetails) {
                  return (
                    <Button
                    id={"alertadditionalButtons"}
                    disableRipple
                    disableTouchRipple
                    className={`formBuilder-MuiButton-outlined ${classes.root}`}
                    size="small"
                      tabIndex={0}
                      style={{...(buttonDetails.styling ? { ...ButtonStyle3, ...buttonDetails.styling } : ButtonStyle3), ...styleObj?.additionalButtons}}
                      onClick={(ev) => handleAdditionalFunction(buttonDetails.callback, ev)}
                    >
                      {buttonDetails.key ? T(buttonDetails.key) : buttonDetails.name ? buttonDetails.name : "Click"}
                    </Button>
                  );
                } else {
                  return null
                }
              })
            : null}

          {(props.alertData && props.alertData.Button2) || (props.alertData && props.alertData.Button2Key) ? (
            <Button
            disableRipple
            id={"alertclosebutton2"}
                    disableTouchRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined ${classes.root}`}
              style={{
                ...(props.alertData && props.alertData.Button2Style
                  ? { ...ButtonStyle2, ...props.alertData.Button2Style }
                  : ButtonStyle2),
                  ...styleObj?.button2Style
              }}
              onClick={(ev) => handleClose(true, ev, props.alertData?.Button2?.name ? props.alertData?.Button2?.name: props.alertData?.Button2Key,props.alertData?.Button2?.callback)}
              color="primary"
            >
              {props.alertData && props.alertData.Button2Key
                ? T(props.alertData.Button2Key)
                : props.alertData && props.alertData.Button2
                ? props.alertData.Button2.name
                : "Click"}
            </Button>
          ) : (
            <></>
          )}
            </DialogActions>
          </div>
        </Dialog>
    );
  }
  else if (props.alertData && props.alertData.showConfirm === "showNotification") {
    if(props.alertData?.placement?.keyAdded) {
      return (
        <div
        className={[classes0.root].join(" ")} 
        style={props.alertData.open === false ?
          { display: "none" } : translationStyles1 ?
          { direction:"rtl"} : {}
          }>
          <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={() => handleClose()}
            anchorOrigin={{ vertical, horizontal }}
            ClickAwayListenerProps={{ onClickAway: () => {} }}
            disableWindowBlurListener = {true}
          >
            <Alert
              action={
                <>
                  {props.alertData && props.alertData.additionalButtons
                    ? props.alertData.additionalButtons.map((buttonDetails, index) => {
                        if (buttonDetails) {
                          return (
                            <Col>
                              <Button
                              id={"alertadditionalButtons2"}
                              className="formBuilder-MuiButton-outlined"
                              disableFocusRipple
                              disableRipple
                              tabIndex={0}
                                size="small"
                                style={
                                  buttonDetails.styling
                                    ? { ...additionalButtonStyle, ...buttonDetails.styling }
                                    : additionalButtonStyle
                                }
                                onClick={(ev) => handleAdditionalFunction(buttonDetails.name, ev)}
                              >
                                {buttonDetails.key
                                  ? T(buttonDetails.key)
                                  : buttonDetails.name
                                  ? buttonDetails.name
                                  : "Click"}
                              </Button>
                            </Col>
                          );
                        } 
                        else {
                          return null;
                        }
                      })
                    : null}
                  {isClose &&
                  (alertType === "success" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                          ? props.alertData.icon2Src.src.default
                          : require("../../Icons/WhiteCross.svg").default
                      }
                      tabIndex="0"
                      id={"alertsuccesscloseicon2"}
                      alt="Img Icon"
                      style={
                        props.alertData &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src.styleData
                          ? { ...whiteCrossIcon, ...props.alertData.icon2Src.styleData }
                          : whiteCrossIcon
                      }
                      onClick={() => handleClose()}
                    />
                  ) : alertType === "error" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                          ? props.alertData.icon2Src.src.default
                          : require("../../Icons/BlackCross.svg").default
                      }
                      alt="Img Icon"
                      tabIndex="0"
                      id={"alerterrorcloseicon3"}
                      style={
                        props.alertData &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src.styleData
                          ? { ...blackCrossIcon, ...props?.alertData?.icon2Src?.styleData }
                          : blackCrossIcon
                      }
                      onKeyDown={(e) => e.key === "Enter" && handleClose()}
                      onClick={() => handleClose()}
                    />
                  ) : alertType === "info" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                          ? props.alertData.icon2Src.src.default
                          : require("../../Icons/BlueCross.svg").default
                      }
                      alt="Img Icon"
                      tabIndex="0"
                      id={"alerterrorcloseicon5"}
                      style={
                        props.alertData &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src.styleData
                          ? { ...blackCrossIcon, ...props.alertData.icon2Src.styleData }
                          : blackCrossIcon
                      }
                      onClick={() => handleClose()}
                    />
                    ) :(
                    <img
                      src={
                        props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                          ? props.alertData.icon2Src.src.default
                          : require("../../Icons/BlackCross.svg").default
                      }
                      alt="Img Icon"
                      tabIndex="0"
                      id={"alerterrorcloseicon4"}
                      style={
                        props.alertData &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src &&
                        props.alertData.icon2Src.styleData
                          ? { ...blackCrossIcon, ...props.alertData.icon2Src.styleData }
                          : blackCrossIcon
                      }
                      onClick={() => handleClose()}
                    />
                  ))}
                </>
              }
              alertData={props?.alertData}
              severity={alertType}
              elevation={elevation}
              variant={variant}
              icon={
                showIcon &&
                <Col
                  style={
                    props.alertData && props.alertData.icon1Style
                      ? { ...notificationIcon1ColStyle, ...props.alertData.icon1Style }
                      : notificationIcon1ColStyle
                  }
                >
                  <>
                    {alertType === "success" ? (
                      <img
                        src={
                          props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                            ? props.alertData.icon1Src.src.default
                            : require("../../Icons/TM_Success.svg").default
                        }
                        alt="Img Icon"
                        style={
                          props.alertData &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src.styleData
                            ? { ...iconStylingData2, ...props.alertData.icon1Src.styleData }
                            : iconStylingData
                        }
                      />
                    ) : alertType === "info" ? (
                      <img
                        src={
                          props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                            ? props.alertData.icon1Src.src.default
                            : require("../../Icons/TM_Info.svg").default
                        }
                        alt="Img Icon"
                        style={
                          props.alertData &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src.styleData
                            ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                            : iconStylingData
                        }
                      />
                    ) : alertType === "warning" ? (
                      <img
                        src={
                          props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                            ? props.alertData.icon1Src.src.default
                            : require("../../Icons/TM_Warning.svg").default
                        }
                        alt="Img Icon"
                        style={
                          props.alertData &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src.styleData
                            ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                            : iconStylingData
                        }
                      />
                    ) : (
                      <img
                        src={
                          props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                            ? props.alertData.icon1Src.src.default
                            : require("../../Icons/TM__Error.svg").default
                        }
                        alt="Img Icon"
                        style={
                          props.alertData &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src &&
                          props.alertData.icon1Src.styleData
                            ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                            : iconStylingData
                        }
                      />
                    )}
                  </>
                </Col>
              }
              style={
                alertType === "success"
                  ? props.alertData && props.alertData.bodyStyle
                    ? { ...notificationBox, ...successNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                    : { ...notificationBox, ...successNotificationBox, ...styleObj?.alert }
                  : alertType === "info"
                  ? props.alertData && props.alertData.bodyStyle
                    ? { ...notificationBox, ...infoNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                    : { ...notificationBox, ...infoNotificationBox, ...styleObj?.alert }
                  : alertType === "warning"
                  ? props.alertData && props.alertData.bodyStyle
                    ? { ...notificationBox, ...warningNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                    : { ...notificationBox, ...warningNotificationBox, ...styleObj?.alert }
                  : props.alertData && props.alertData.bodyStyle
                  ? { ...notificationBox, ...errorNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                  : { ...notificationBox, ...errorNotificationBox, ...styleObj?.alert }
              }
            >
              <span  id = "messageContainer" ref={messageContainerEl} style={props.alertData && props.alertData.contentTextStyle ? props.alertData.contentTextStyle : null}>
                {alertMsg}
              </span>
            </Alert>
          </Snackbar>
        </div>
      );
    }
    return ReactDOM.createPortal(
      <div
      className={[classes0.root, classes0.addedTop].join(" ")} 
      style={props.alertData.open === false ?
        { display: "none" } : translationStyles1 ?
        { direction:"rtl", ...(props?.alertData?.placement ? {width:"100%", height
          :"100%"
         } : {}) }
         : props?.alertData?.placement ? { width:"100%", height
          :"100%"} : {}
        }>
        <Snackbar
          open={open}
          autoHideDuration={autoHideDuration}
          onClose={() => handleClose()}
          anchorOrigin={{ vertical, horizontal }}
          ClickAwayListenerProps={{ onClickAway: () => {} }}
          disableWindowBlurListener = {true}
        >
          <Alert
            action={
              <>
                {props.alertData && props.alertData.additionalButtons
                  ? props.alertData.additionalButtons.map((buttonDetails, index) => {
                      if (buttonDetails) {
                        return (
                          <Col>
                            <Button
                            id={"alertadditionalButtons2"}
                            className="formBuilder-MuiButton-outlined"
                            disableFocusRipple
                            disableRipple
                            tabIndex={0}
                              size="small"
                              style={
                                buttonDetails.styling
                                  ? { ...additionalButtonStyle, ...buttonDetails.styling }
                                  : additionalButtonStyle
                              }
                              onClick={(ev) => handleAdditionalFunction(buttonDetails.name, ev)}
                            >
                              {buttonDetails.key
                                ? T(buttonDetails.key)
                                : buttonDetails.name
                                ? buttonDetails.name
                                : "Click"}
                            </Button>
                          </Col>
                        );
                      } 
                      else {
                        return null;
                       }
                    })
                  : null}
                {isClose &&
                (alertType === "success" ? (
                  <img
                    src={
                      props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                        ? props.alertData.icon2Src.src.default
                        : require("../../Icons/WhiteCross.svg").default
                    }
                    tabIndex="0"
                    id={"alertsuccesscloseicon2"}
                    alt="Img Icon"
                    style={
                      props.alertData &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src.styleData
                        ? { ...whiteCrossIcon, ...props.alertData.icon2Src.styleData }
                        : whiteCrossIcon
                    }
                    onClick={() => handleClose()}
                  />
                ) : alertType === "error" ? (
                  <img
                    src={
                      props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                        ? props.alertData.icon2Src.src.default
                        : require("../../Icons/BlackCross.svg").default
                    }
                    alt="Img Icon"
                    tabIndex="0"
                    id={"alerterrorcloseicon3"}
                    style={
                      props.alertData &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src.styleData
                        ? { ...blackCrossIcon, ...props?.alertData?.icon2Src?.styleData }
                        : blackCrossIcon
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleClose()}
                    onClick={() => handleClose()}
                  />
                ) : alertType === "info" ? (
                  <img
                    src={
                      props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                        ? props.alertData.icon2Src.src.default
                        : require("../../Icons/BlueCross.svg").default
                    }
                    alt="Img Icon"
                    tabIndex="0"
                    id={"alerterrorcloseicon5"}
                    style={
                      props.alertData &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src.styleData
                        ? { ...blackCrossIcon, ...props.alertData.icon2Src.styleData }
                        : blackCrossIcon
                    }
                    onClick={() => handleClose()}
                  />
                  ) :(
                  <img
                    src={
                      props.alertData && props.alertData.icon2Src && props.alertData.icon2Src
                        ? props.alertData.icon2Src.src.default
                        : require("../../Icons/BlackCross.svg").default
                    }
                    alt="Img Icon"
                    tabIndex="0"
                    id={"alerterrorcloseicon4"}
                    style={
                      props.alertData &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src &&
                      props.alertData.icon2Src.styleData
                        ? { ...blackCrossIcon, ...props.alertData.icon2Src.styleData }
                        : blackCrossIcon
                    }
                    onClick={() => handleClose()}
                  />
                ))}
              </>
            }
            alertData={props?.alertData}
            severity={alertType}
            elevation={elevation}
            variant={variant}
            icon={
              showIcon &&
              <Col
                style={
                  props.alertData && props.alertData.icon1Style
                    ? { ...notificationIcon1ColStyle, ...props.alertData.icon1Style }
                    : notificationIcon1ColStyle
                }
              >
                <>
                  {alertType === "success" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                          ? props.alertData.icon1Src.src.default
                          : require("../../Icons/TM_Success.svg").default
                      }
                      alt="Img Icon"
                      style={
                        props.alertData &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src.styleData
                          ? { ...iconStylingData2, ...props.alertData.icon1Src.styleData }
                          : iconStylingData
                      }
                    />
                  ) : alertType === "info" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                          ? props.alertData.icon1Src.src.default
                          : require("../../Icons/TM_Info.svg").default
                      }
                      alt="Img Icon"
                      style={
                        props.alertData &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src.styleData
                          ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                          : iconStylingData
                      }
                    />
                  ) : alertType === "warning" ? (
                    <img
                      src={
                        props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                          ? props.alertData.icon1Src.src.default
                          : require("../../Icons/TM_Warning.svg").default
                      }
                      alt="Img Icon"
                      style={
                        props.alertData &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src.styleData
                          ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                          : iconStylingData
                      }
                    />
                  ) : (
                    <img
                      src={
                        props.alertData && props.alertData.icon1Src && props.alertData.icon1Src
                          ? props.alertData.icon1Src.src.default
                          : require("../../Icons/TM__Error.svg").default
                      }
                      alt="Img Icon"
                      style={
                        props.alertData &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src &&
                        props.alertData.icon1Src.styleData
                          ? { ...iconStylingData, ...props.alertData.icon1Src.styleData }
                          : iconStylingData
                      }
                    />
                  )}
                </>
              </Col>
            }
            style={
              alertType === "success"
                ? props.alertData && props.alertData.bodyStyle
                  ? { ...notificationBox, ...successNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                  : { ...notificationBox, ...successNotificationBox, ...styleObj?.alert }
                : alertType === "info"
                ? props.alertData && props.alertData.bodyStyle
                  ? { ...notificationBox, ...infoNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                  : { ...notificationBox, ...infoNotificationBox, ...styleObj?.alert }
                : alertType === "warning"
                ? props.alertData && props.alertData.bodyStyle
                  ? { ...notificationBox, ...warningNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                  : { ...notificationBox, ...warningNotificationBox, ...styleObj?.alert }
                : props.alertData && props.alertData.bodyStyle
                ? { ...notificationBox, ...errorNotificationBox, ...props.alertData.bodyStyle, ...styleObj?.alert }
                : { ...notificationBox, ...errorNotificationBox, ...styleObj?.alert }
            }
          >
            <span  id = "messageContainer" ref={messageContainerEl} style={props.alertData && props.alertData.contentTextStyle ? props.alertData.contentTextStyle : null}>
              {alertMsg}
            </span>
          </Alert>
        </Snackbar>
      </div>, document.body
    );
  }
  else {
    return <></>;
  }
}
export default CustomizedAlert;